import Search from './Search';

export default Search;



// WEBPACK FOOTER //
// ./src/js/Search/index.js